import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [RouterModule, HttpClientModule, ReactiveFormsModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'] 
})
export class LoginComponent implements OnInit {
  public loginForm!: FormGroup;
  public isLoading: boolean = false; 

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]], 
      password: ['', Validators.required]
    });
  }

  login(): void {
    // Dados do formulário enviados no corpo da requisição
    const loginData = this.loginForm.value;
    this.isLoading = true;
    this.authService.login(loginData).subscribe(
      (res) => {
        if (res && res.status) {
          this.isLoading = false;
          this.loginForm.reset();
          this.router.navigate(['home']);
          localStorage.setItem('plan', res.plan);
        } else {
          this.isLoading = false;
          Swal.fire({
            text: 'Usuário não encontrado ou credenciais incorretas...',
            icon: 'error',
            toast: true,
            position: 'bottom-end', 
            showConfirmButton: false, 
            timer: 4000, 
            timerProgressBar: true
          });
        }
      },
      (err) => {
        this.isLoading = false;
        Swal.fire({
          text: 'Algo deu errado...',
          icon: 'error',
            toast: true,
            position: 'bottom-end', 
            showConfirmButton: false, 
            timer: 4000, 
            timerProgressBar: true
        });
      }
    );
  }
}
